import { reskinStyles } from 'core/components/theme/theme-variant';

export default (theme) => ({
  cardBody: {
    background: theme.colorPalette.beige_25,
    // Reskin: section bodies are white inside the outlined card.
    ...reskinStyles(theme, { background: theme.colors.card_background_primary_editable }),
    width: '100%',
    margin: 0,
    padding: 24,
    borderRadius: `0 0 ${theme.sizes.roundCorners}px ${theme.sizes.roundCorners}px`
  }
});
